import { withAvailabilityTimeout } from "./availabilityTimeout";

const TRANSIENT_UPSTREAM_STATUSES = new Set([502, 503, 504]);
const RETRY_DELAYS_MS = [750, 1500];

const waitForRetry = (delay, signal) => new Promise((resolve, reject) => {
  let timer;
  const abort = () => {
    clearTimeout(timer);
    signal.removeEventListener("abort", abort);
    const error = new Error("Booking lookup cancelled.");
    error.name = "AbortError";
    reject(error);
  };
  if (signal.aborted) { abort(); return; }
  signal.addEventListener("abort", abort, { once: true });
  timer = setTimeout(() => {
    signal.removeEventListener("abort", abort);
    resolve();
  }, delay);
});

// Call only for explicit read operations, even where the API uses POST.
// One timeout bounds all attempts, including backoff. Never wrap store/payment.
export const withBookingReadRetry = (request, signal) => withAvailabilityTimeout(async (requestSignal) => {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await request(requestSignal);
    } catch (error) {
      if (requestSignal.aborted || !TRANSIENT_UPSTREAM_STATUSES.has(error?.response?.status)
          || attempt >= RETRY_DELAYS_MS.length) throw error;
      await waitForRetry(RETRY_DELAYS_MS[attempt], requestSignal);
    }
  }
}, undefined, signal);
